export const formatPrice = (
  price: string | number | null | undefined,
  showCurrency: boolean = false,
  currency?: string,
): string => {
  if (!price) return "0";
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: 2,
    style: showCurrency ? "currency" : "decimal",
    currency: currency || "INR",
  }).format(Number(price));
};
